export const MIN_POSITIVE_REVIEW_RATING = 3;
export const DELIVEROO_DAYS_UNTIL_CANT_BE_ANSWERED = 60;
export const UBEREATS_DAYS_UNTIL_CANT_BE_ANSWERED = 14;
export const DOORDASH_DAYS_UNTIL_CANT_BE_ANSWERED = 7;
export const MAX_REVIEW_REPLY_RETRIES = 20;

export const REVIEW_PUBLIC_BUSINESS_ID_SEPARATOR = '___';
